import React, { SFC } from 'react';
import { ISubscription } from 'interfaces/IProductData';
import Translate from 'components/Translate';
import { CurrencyFormat } from 'components/CurrencyFormat';
import { paymentService } from 'services/PaymentService';

interface IPriceProps {
  subscription: ISubscription;
}

// tslint:disable-next-line:variable-name
export const SubscriptionWithTrial: SFC<IPriceProps> = props => {
  const { subscription } = props;

  return (
    <div className="chk-subscription">
      <div className="chk-subscription__text">
        <Translate term="Assinatura" />
      </div>
      <div className="chk-subscription__value theme-label">
        <CurrencyFormat value={subscription.price} />
      </div>
      <div className="chk-subscription__frequency">
        <Translate
          term={`a cada {frequency} ${paymentService.getNormalizedFrequencyType(subscription.frequencyType, subscription.frequency)}`}
          properties={{
            tax: <CurrencyFormat value={subscription.tax} />,
            frequency: subscription.frequency
          }}
        />
      </div>
      <div className="chk-subscription__trial">
        <span className="theme-button">
          {subscription.hasTrialTax ? (
            <span>
              <Translate
                term={`{trial} ${subscription.trial > 1 ? 'dias' : 'dia'} na adesão por`}
                properties={{
                  trial: subscription.trial
                }}
              />{' '}
              <CurrencyFormat value={subscription.trialTax} />!
            </span>
          ) : (
            <Translate
              term={`{trial} ${subscription.trial > 1 ? 'dias' : 'dia'} grátis na adesão!`}
              properties={{
                trial: subscription.trial
              }}
            />
          )}
        </span>
      </div>
    </div>
  );
};
